import { Table } from "@devexpress/dx-react-grid-bootstrap4";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import { faSignInAlt } from "@fortawesome/free-solid-svg-icons/faSignInAlt";
import { faSortAmountUp } from "@fortawesome/free-solid-svg-icons/faSortAmountUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//@ts-ignore
import * as google_protobuf_timestamp_pb from "google-protobuf/google/protobuf/timestamp_pb";
import { KeycloakProfile } from "keycloak-js";
import queryString from "query-string";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import { defineMessage, FormattedMessage, useIntl } from "react-intl";
import { useHistory, useRouteMatch } from "react-router";
import styled from "styled-components";
import SweetAlert from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import { useRoleChecker, withAuthorizationVerifier } from "../../components/authorization-verifier";
import { IPropertyChainData, useChainData } from "../../components/chain-data-provider";
import { useKeycloak } from "../../components/keycloak-provider";
import { useLocaleProvider } from "../../components/locale-provider";
import { useLoyaltyBrand } from "../../components/loyalty-brand-provider";
import { usePropertyConfiguration } from "../../components/property-configuration-provider";
import schema from "../../gen/schema/witbooking.loyalty.customer.v1/Customer.json";
import { Localizable } from "../../gen/witbooking/backoffice/common/common_pb";
import { LoyaltyTierAPIPromiseClient } from "../../gen/witbooking/backoffice/loyalty/tier/v1/loyalty_tier_api_grpc_web_pb";
import {
  GetLoyaltyTiersByBrandRequest,
  LoyaltyConstantTier,
  LoyaltyDerivedTier,
} from "../../gen/witbooking/backoffice/loyalty/tier/v1/loyalty_tier_api_pb";
import { CustomerAPIPromiseClient } from "../../gen/witbooking/loyalty/customer/v1/customer_api_grpc_web_pb";
import {
  ChangeStatusCustomerRequest,
  Customer,
  CustomerOrganization,
  CustomerPreference,
  DeleteCustomerRequest,
  GetCustomerRequest,
  ListCustomersRequest,
  TierType,
  UpdateCustomerRequest,
} from "../../gen/witbooking/loyalty/customer/v1/customer_api_pb";
import { useAuthorizer } from "../../lib/action-authorizer";
import actions from "../../lib/actions";
import authorizeActions from "../../lib/actions";
import { useConfig } from "../../lib/config";
import { SECTION, TIER_TYPE_EXTERNAL } from "../../lib/constants";
import { asUTC, asUTCTime } from "../../lib/dateUtils";
import { useGrpcClient, useLoyaltyGrpcCall, usePropertyGrpcCall } from "../../lib/grpc";
import { useApiClient, useBackofficeClient } from "../../lib/http";
import { usePermissions } from "../../lib/permissions";
import { CALL_CENTER_LIGHT_USER, CALL_CENTER_USER } from "../../lib/roles";
import {
  ImpersonateLoyaltyCustomer,
  isDreamplaceEngine,
} from "../dreamplaceInsertReservationCallCenter/InsertReservationCallCenter";
import { LoyaltyTag } from "../loyaltyPreferences/domain/LoyaltyTag";
import { useSections } from "../loyaltyPreferences/infrastructure/hooks/sections.hook";
import {
  DefaultTableRowActionsProps,
  Delete,
  defaultDeleteMessages,
  Edit,
  StyledReactTooltip,
} from "../shared/actions/tableActions";
import {
  dateFilter,
  inputFilter,
  selectFilter,
  selectorFilter,
} from "../shared/crud/filter-widgets";
import { FormConfiguration } from "../shared/crud/form";
import { TableColumns, TableFilters } from "../shared/crud/list";
import SimpleCrud from "../shared/crud/simple-crud";
import { RendererProps } from "../shared/renderers";
import * as TableRenderers from "../shared/renderers/table";
import { DateRenderer, mapRenderer, StringRenderer } from "../shared/renderers/table";
import { DateFilterProps } from "../shared/widgets";
import { ArrayAsString } from "../shared/widgets/arrayAsString";
import { CountrySelector } from "../shared/widgets/countrySelector";
import { DOBSelector } from "../shared/widgets/DOBSelector";
import { LocaleSelector } from "../shared/widgets/localeSelector";
import { LoyaltyOrganizationSelector } from "../shared/widgets/loyaltyOrganizationSelector";
import { LoyaltyTierSelector } from "../shared/widgets/loyaltyTierSelector";
import { SwitchGroup } from "../shared/widgets/SwitchGroup";
import { APP_COLORS } from "../witadmin/Common/constants";
import SwitchComponent from "../witadmin/CRUD/Common/SwitchGroup";
import { FormContainer } from "./form-style";
import { customerMessages, customerTableHeaderMessages } from "./messages";
import { LoyaltyPreferencesWidget } from "./widgets/LoyaltyPreferencesWidget";
import { AxiosError } from "axios";

interface CustomerFilters {
  name: string;
  lastName: string;
  emailAddress: string;
  address: string;
  city: string;
  referrer: string;
  active: string;
  communicationConsent: string;
  tierType: string;
  createdAt: DateFilterProps<string>;
}

let modifiedSchema = schema;

//Schema generates incorrectly for proto.google.protobuf.Timestamp() and causes validate error
// @ts-ignore
modifiedSchema.additionalProperties = true;
// @ts-ignore
modifiedSchema.properties.createdAt.type = "object";
// @ts-ignore
modifiedSchema.properties.updatedAt.type = "object";
// @ts-ignore
modifiedSchema.properties.birthDate.type = "object";
// @ts-ignore
delete modifiedSchema.properties.customerTransactionData;

modifiedSchema.properties.status = {
  // @ts-ignore
  type: "integer",
};
modifiedSchema.properties.location = {
  ...modifiedSchema.properties.location,
  // @ts-ignore
  required: ["country"],
};

const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;

  & .witadmin-bs3 .form-group {
    margin-bottom: 0;
  }

  & .witadmin-bs3 label {
    margin-bottom: 0;
  }
`;

function organizationsListFromObject(obj: CustomerOrganization.AsObject[]): CustomerOrganization[] {
  if (obj) {
    return obj.map(it => {
      const result = new CustomerOrganization();
      result.setId(it.id);
      result.setTicker(it.ticker);
      result.setOrganizationType(it.organizationType);
      return result;
    });
  } else {
    return [];
  }
}

function customerPlanFromObject(
  obj: Customer.AsObject,
  constantTiers: (LoyaltyConstantTier.AsObject | undefined)[] | undefined,
  brandId: string
): Customer {
  const localizable = new Localizable();
  localizable.setCountry(obj?.location?.country || "AF");
  localizable.setCity(obj.location!!.city);
  localizable.setAddress(obj.location!!.address);
  localizable.setZipCode(obj.location!!.zipCode);

  const result = new Customer();
  result.setId(obj.id);
  result.setAuthenticationServiceId(obj.authenticationServiceId);
  result.setBrandId(brandId);
  result.setName(obj.name);
  result.setLastName(obj.lastName);
  result.setEmailAddress(obj.emailAddress);
  result.setPhoneNumber(obj.phoneNumber);
  // @ts-ignore
  const birthDate = new proto.google.protobuf.Timestamp();
  birthDate.setNanos(obj.birthDate?.nanos);
  birthDate.setSeconds(obj.birthDate?.seconds);
  result.setBirthDate(birthDate);
  result.setEmailAddress(obj.emailAddress);
  result.setLocation(localizable);
  result.setReferrer(obj.referrer);
  result.setTierId(obj.tierId);
  result.setTagsList(obj.tagsList);
  result.setOrganizationsList(organizationsListFromObject(obj.organizationsList));
  result.setStatus(obj.status);
  result.setCommunicationConsent(obj.communicationConsent);
  result.setLocale(obj.locale);

  if (constantTiers) {
    const tierType = constantTiers.find(it => it?.externalSystemId === obj.tierId)
      ? TierType.CONSTANT
      : TierType.DERIVED;
    result.setTierType(tierType);
  }

  result.setLoyaltyPoints(obj.loyaltyPoints);
  // @ts-ignore
  const createdAt = new proto.google.protobuf.Timestamp();
  createdAt.setNanos(obj.createdAt?.nanos);
  createdAt.setSeconds(obj.createdAt?.seconds);
  result.setCreatedAt(createdAt);
  // @ts-ignore
  const updatedAt = new proto.google.protobuf.Timestamp();
  updatedAt.setNanos(obj.updatedAt?.nanos);
  updatedAt.setSeconds(obj.updatedAt?.seconds);
  result.setUpdatedAt(updatedAt);
  result.setLegalIdentifier(obj.legalIdentifier);

  if (obj.preferencesList) {
    result.setPreferencesList(
      obj.preferencesList.map(p => {
        const preference = new CustomerPreference();
        preference.setId(p.id);
        preference.setTicker(p.ticker);
        return preference;
      })
    );
  }

  return result;
}

export const filters = [
  "name",
  "lastName",
  "emailAddress",
  "referrer",
  "tagsList",
  "tierType",
  "legalIdentifier",
  "location.country",
  "location.city",
  "location.address",
  "location.zipCode",
  "organizationsList",
  "phoneNumber",
  "active",
  "createdAt",
  "communicationConsent",
  "locale",
  "preferencesList",
];

const _tableFilters: TableFilters<any, any> = filters.reduce(
  (accum, curr) => ({
    ...accum,
    [curr]: {
      filterFn: "async",
      widget: inputFilter,
    },
  }),
  {}
);

const columnVisibilityExtensions = ["name", "lastName", "emailAddress", "tier"].map(it => ({
  columnName: it,
  togglingEnabled: false,
}));

const defaultPageSize = 50;
const pageSizes = [50, 100, 500];

function buildEngineUrl(
  mainDomain: string,
  customDomain: string,
  propertyTicker: string,
  isCallCenterUser: boolean,
  result: string,
  encodedAffiliate: string,
  encodedAffiliateAttributes: string,
  engineUrl: string,
  isChain: boolean
): string {
  return queryString.stringifyUrl({
    url: `https://${mainDomain || customDomain || engineUrl}/${
      isChain ? "chain" : "hotel"
    }/${propertyTicker}`,
    query: {
      session: result,
      encodedAffiliate,
      origin: isCallCenterUser ? "callcenter" : "backoffice",
      encodedAffiliateAttributes,
    },
  });
}

function buildListCustomerRequest(
  allTiers: (LoyaltyConstantTier.AsObject | LoyaltyDerivedTier.AsObject | undefined)[],
  {
    filterValues,
    currentPage,
    pageSize,
    brandId,
  }: {
    filterValues: Partial<CustomerFilters>;
    currentPage: number;
    pageSize: number;
    brandId: string;
  }
): ListCustomersRequest {
  const request = new ListCustomersRequest();
  request.setPageSize(pageSize);
  request.setPageNumber(currentPage);
  request.setBrandId(brandId);

  // Customers endpoint doesn't send tier name, so we must filter here to find out the tierId
  const tierType = filterValues?.tierType;
  if (tierType && allTiers) {
    const tier = allTiers.find(it => it?.ticker.toLowerCase().includes(tierType.toLowerCase()));
    request.getFiltersMap().set("tierId", tier?.externalSystemId);
  }

  if (filterValues.active === "true") {
    request.getFiltersMap().set("status", "ACTIVE");
  } else if (filterValues.active === "false") {
    request.getFiltersMap().set("status", "INACTIVE");
  }

  if (filterValues.communicationConsent === "true") {
    request.getFiltersMap().set("communicationConsent", "true");
  } else if (filterValues.communicationConsent === "false") {
    request.getFiltersMap().set("communicationConsent", "false");
  }

  if (filterValues.createdAt) {
    const { startDate, endDate } = filterValues.createdAt;
    if (startDate.length > 0 && endDate.length > 0) {
      request.getFiltersMap().set("filterDatesBy", "createdAt");
      request.getFiltersMap().set("fromDate", startDate);
      request.getFiltersMap().set("toDate", endDate);
    }
  }

  if (typeof filterValues === "object") {
    Object.entries(filterValues).forEach(([key, value]) => {
      if (
        key !== "tierType" &&
        key !== "active" &&
        key !== "communicationConsent" &&
        key !== "createdAt" &&
        value
      ) {
        request.getFiltersMap().set(key, value);
      }
    });
  }

  return request;
}

function LoyaltyCustomerCrud({
  propertyTicker,
  email,
}: {
  propertyTicker: string;
  email: string | undefined;
}) {
  const chainData: IPropertyChainData | undefined | null = useChainData();
  const brand = useLoyaltyBrand()?.ticker || "";
  const brandId = useLoyaltyBrand()?.externalSystemId || "";
  const mainDomain = useLoyaltyBrand()?.mainDomain || "";
  const propertyConfiguration = usePropertyConfiguration();
  const customDomain = propertyConfiguration?.customDomain || "";
  // Salesforce owns who belongs to a B2B company or agency, unless the backoffice is in master mode.
  const organizationsReadOnly =
    propertyConfiguration?.["b2bChannelEnabled"] === "1" &&
    propertyConfiguration?.["b2bMasterModeEnabled"] !== "1";
  // A company or agency user is Salesforce's; a particular has no organization and stays editable.
  const isB2bMember = useCallback(
    (customer?: Customer.AsObject) =>
      organizationsReadOnly && (customer?.organizationsList?.length ?? 0) > 0,
    [organizationsReadOnly]
  );
  const client = useGrpcClient(CustomerAPIPromiseClient);
  const tierClient = useGrpcClient(LoyaltyTierAPIPromiseClient);
  const [allTiers, setAllTiers] = useState<
    (LoyaltyConstantTier.AsObject | LoyaltyDerivedTier.AsObject | undefined)[] | undefined
  >();
  const [constantTiers, setConstantTiers] = useState<
    (LoyaltyConstantTier.AsObject | undefined)[] | undefined
  >();
  const [forceUpdate, setForceUpdate] = useState(0);
  const [unmaskedSendLoading, setUnmaskedSendLoading] = useState(false);
  const [reload, setReload] = useState(true);
  const [userProfile, setUserProfile] = useState<KeycloakProfile | undefined>();

  const match = useRouteMatch();
  const history = useHistory();
  const config = useConfig();
  const permissions = usePermissions();
  const authorizer = useAuthorizer();
  const keycloak = useKeycloak();
  const { currentLocale } = useLocaleProvider();

  const httpClient = useApiClient();
  const backofficeClient = useBackofficeClient();
  const listCustomers = usePropertyGrpcCall(client, client.listCustomers);
  const getCustomer = usePropertyGrpcCall(client, client.getCustomer);
  const updateCustomer = usePropertyGrpcCall(client, client.updateCustomer);
  const createCustomer = usePropertyGrpcCall(client, client.createCustomer);
  const deleteCustomer = usePropertyGrpcCall(client, client.deleteCustomer);
  const changeStatusCustomer = usePropertyGrpcCall(client, client.changeStatusCustomer);
  const getLoyaltyTiersByBrand = useLoyaltyGrpcCall(tierClient, tierClient.getLoyaltyTiersByBrand);
  const isCallCenterUser = useRoleChecker([CALL_CENTER_LIGHT_USER, CALL_CENTER_USER]);
  const intl = useIntl();

  const { sections } = useSections(brandId, { loadSections: true });

  const canViewUnmaskedData = authorizer.canExecute(authorizeActions.DownloadCustomersExcel);

  const tableFilters = useMemo(
    () => ({
      ..._tableFilters,
      "location.country": {
        filterFn: "async" as const,
        title: customerTableHeaderMessages.country,
        widget: inputFilter,
      },
      active: {
        filterFn: "async" as const,
        widget: selectFilter(intl, customerMessages.activeQuestion),
      },
      createdAt: {
        filterFn: "async" as const,
        widget: dateFilter("", intl),
      },
      communicationConsent: {
        filterFn: "async" as const,
        widget: selectFilter(intl, customerMessages.communicationConsent),
      },
      preferencesList: {
        filterFn: "async" as const,
        widget: selectorFilter(
          intl.formatMessage(customerTableHeaderMessages.preferencesList),
          sections
            ?.flatMap(it => it.tags)
            .map(it => ({
              value: it.ticker,
              label: it.getTranslation(currentLocale).name,
            })) ?? []
        ),
      },
    }),
    [currentLocale, intl, sections]
  );

  useEffect(() => {
    async function loadProfile() {
      const profile = await keycloak.loadUserProfile();
      setUserProfile(profile);
    }

    loadProfile().catch(err => console.error("Error loading user profile", err));
  }, [keycloak]);

  useEffect(() => {
    const asyncFun = async () => {
      if (!allTiers && brand) {
        const request = new GetLoyaltyTiersByBrandRequest();
        request.setBrandTicker(brand);
        const response = await getLoyaltyTiersByBrand(request);
        if (response) {
          const res = response.toObject();
          setAllTiers(
            res.tiersList.map(it => (it.constantTier ? it.constantTier : it.derivedTier))
          );
          setConstantTiers(res.tiersList.map(it => it.constantTier).filter(it => it));
          setForceUpdate(forceUpdate + 1);
        }
      }
    };
    asyncFun();
  }, [allTiers, brand, forceUpdate, getLoyaltyTiersByBrand]);

  const userAttributes = useMemo(() => {
    const kcAttributesAllowed = ["paycomet_ivr_station_id"];
    let attributes = {};
    if (userProfile && userProfile.attributes) {
      attributes = Object.entries(userProfile.attributes)
        .map(([key, value]) => [key, Array.isArray(value) && value.length > 0 ? value[0] : ""])
        .reduce((acc, [key, value]) => {
          if (kcAttributesAllowed.includes(key)) {
            acc[key] = value;
          }
          return acc;
        }, {} as { [key: string]: string });
    }
    return JSON.stringify(attributes);
  }, [userProfile]);

  const onGetAll = useCallback(
    async ({ filterValues, currentPage, pageSize, setTotalRowsCount }) => {
      if (brandId && allTiers) {
        const request = buildListCustomerRequest(allTiers, {
          brandId,
          filterValues,
          currentPage,
          pageSize,
        });

        const response = await listCustomers(request);
        setTotalRowsCount(response.getTotalElements());

        return response.getCustomersList().map(m => {
          const responseObject = { ...m.toObject(), lCountry: m.toObject().location?.country };
          delete responseObject.customerTransactionData;
          return responseObject;
        });
      }
    },
    [brandId, allTiers, listCustomers]
  );

  const onGetOne = useCallback(
    async (id: string) => {
      const request = new GetCustomerRequest();
      request.setId(id);
      const response = (await getCustomer(request)).getCustomer();
      if (response) {
        const responseObject = response.toObject();
        delete responseObject.customerTransactionData;
        return responseObject;
      } else throw new Error("Unexpected reply obtaining customer");
    },
    [getCustomer]
  );

  const onUpdate: (entity: Customer.AsObject) => Promise<void> = useCallback(
    async entity => {
      if (isB2bMember(entity)) {
        throw new Error(intl.formatMessage(customerMessages.b2bMemberManagedBySalesforce));
      }
      const customer = customerPlanFromObject(entity, constantTiers, brandId);
      const request = new UpdateCustomerRequest();
      request.setCustomer(customer);
      try {
        await updateCustomer(request);
      } catch (e) {
        //@ts-ignore
        if (/Invalid organization \/ tier combination/.test(e.message)) {
          throw new Error("Invalid organization / tier combination");
        }
        throw e;
      }
    },
    [constantTiers, brandId, updateCustomer, isB2bMember, intl]
  );

  const onCreate: (entity: Customer.AsObject) => void = useCallback(
    async entity => {
      const customer = customerPlanFromObject(entity, constantTiers, brandId);
      const request = new UpdateCustomerRequest();
      request.setCustomer(customer);
      try {
        await createCustomer(request);
      } catch (e) {
        //@ts-ignore
        if (/Invalid organization \/ tier combination/.test(e.message)) {
          throw new Error("Invalid organization / tier combination");
        }
        throw e;
      }
    },
    [constantTiers, brandId, createCustomer]
  );

  const showMessageDeleted = useCallback(
    (ok: boolean = true) => {
      SweetAlert.fire({
        title: ok
          ? intl.formatMessage(customerMessages.deletedSucces)
          : intl.formatMessage(customerMessages.deletedError),
        icon: ok ? "success" : "warning",
        text: ok
          ? intl.formatMessage(customerMessages.deletedSuccesDescription)
          : intl.formatMessage(customerMessages.deletedErrorDescription),
        confirmButtonColor: APP_COLORS.green,
      });
    },
    [intl]
  );

  const onDelete = useCallback(
    async (id: string) => {
      const request = new DeleteCustomerRequest();
      request.setId(id);
      try {
        await deleteCustomer(request);
        showMessageDeleted();
      } catch (error) {
        console.error(`Error request ${request}. error: ${error}`);
        showMessageDeleted(false);
      }
    },
    [deleteCustomer, showMessageDeleted]
  );

  const TierRenderer = useCallback(
    ({ rows }: RendererProps<TierType | undefined>) => {
      const tier = allTiers?.find(it => it?.externalSystemId === rows?.tierId);
      return (
        <div>
          {tier?.ticker} ({TIER_TYPE_EXTERNAL[rows?.tierType]})
        </div>
      );
    },
    [allTiers]
  );

  const sendWelcomeValidatedEmailToCustomer: (
    brand: string,
    customerId: string,
    emailAddress: string
  ) => void = useCallback(
    async (brand, customerId, emailAddress) => {
      try {
        await httpClient.post(`/api/loyalty/${brand}/customer/${customerId}/validated`, {});
      } catch (e) {
        await SweetAlert.fire({
          title: intl.formatMessage(customerMessages.popupWelcomeValidatedEmailErrorTitle, {
            email: emailAddress,
          }),
          text: intl.formatMessage(customerMessages.popupWelcomeValidatedEmailErrorDescription, {
            email: emailAddress,
          }),
          icon: "error",
          confirmButtonText: intl.formatMessage(customerMessages.ok),
          confirmButtonColor: APP_COLORS.green,
        });
      }
    },
    [httpClient, intl]
  );

  const CSVRenderers = useMemo(
    () => ({
      birthDate: (values: google_protobuf_timestamp_pb.Timestamp.AsObject) => {
        // @ts-ignore
        const protoDate = new proto.google.protobuf.Timestamp();
        protoDate.setSeconds(values.seconds);
        protoDate.setNanos(values.nanos);
        return asUTC(protoDate.toDate());
      },
      organizationsList: (values: CustomerOrganization.AsObject[]) => {
        if (!values) {
          return "";
        }
        return values.map(it => it.ticker).join(",");
      },
      createdAt: (values: google_protobuf_timestamp_pb.Timestamp.AsObject) => {
        if (!values) {
          return "";
        }
        // @ts-ignore
        const protoDate = new proto.google.protobuf.Timestamp();
        protoDate.setSeconds(values.seconds);
        protoDate.setNanos(values.nanos);
        return asUTCTime(protoDate.toDate());
      },
      tierType: (values: number, fields: { [key: string]: any }) => {
        const tier = allTiers?.find(it => it?.externalSystemId === fields?.tierId);
        return `${tier?.ticker} (${TIER_TYPE_EXTERNAL[fields?.tierType]})`;
      },
    }),
    [allTiers]
  );

  const formConfiguration: FormConfiguration<Customer.AsObject> = useMemo(
    () => ({
      __fieldOrder: [
        "status",
        "id",
        "tierId",
        "organizationsList",
        "name",
        "lastName",
        "emailAddress",
        "phoneNumber",
        "birthDate",
        "legalIdentifier",
        "*",
      ],
      __useProtoStyleArrays: true,
      status: {
        widget: SwitchGroup,
        messages: {
          label: defineMessage({
            id: "default.active",
            defaultMessage: "active",
          }),
        },
      },
      id: {
        default: () => uuidv4(),
        readonly: true,
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.id",
            defaultMessage: "id",
          }),
          helpText: defineMessage({
            id: "loyaltyCustomer.idHelpText",
            defaultMessage: "HelpText",
          }),
        },
      },
      authenticationServiceId: {
        default: () => uuidv4(),
        hidden: true,
        readonly: true,
      },
      brandId: {
        hidden: true,
        default: () => brandId,
      },
      loyaltyPoints: {
        hidden: true,
      },
      createdAt: {
        hidden: false,
      },
      updatedAt: {
        hidden: true,
      },
      tierType: {
        hidden: true,
        default: () => TierType.DERIVED,
      },
      tagsList: {
        readonly: isNew => !isNew,
        fieldWidget: ArrayAsString,
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.tagsList",
            defaultMessage: "tagsList",
          }),
        },
      },
      birthDate: {
        fieldWidget: DOBSelector,
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.birthDate",
            defaultMessage: "birthDate",
          }),
        },
      },
      name: {
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.name",
            defaultMessage: "name",
          }),
        },
      },
      lastName: {
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.lastName",
            defaultMessage: "lastName",
          }),
        },
      },
      emailAddress: {
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.emailAddress",
            defaultMessage: "emailAddress",
          }),
        },
      },
      phoneNumber: {
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.phoneNumber",
            defaultMessage: "phoneNumber",
          }),
        },
      },
      referrer: {
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.referrerLong",
            defaultMessage: "referrer",
          }),
        },
      },
      tierId: {
        fieldWidget: LoyaltyTierSelector,
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.tierId",
            defaultMessage: "tierId",
          }),
        },
      },
      legalIdentifier: {
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.legalIdentifier",
            defaultMessage: "legalIdentifier",
          }),
        },
      },
      organizationsList: {
        fieldWidget: LoyaltyOrganizationSelector,
        readonly: organizationsReadOnly,
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.organizationsList",
            defaultMessage: "organizationsList",
          }),
        },
      },
      location: {
        hideTitle: true,
        children: {
          __fieldOrder: ["country", "city", "address", "*"],
          country: {
            widget: CountrySelector,
            messages: {
              label: defineMessage({ id: "loyaltyCustomer.country", defaultMessage: "country" }),
            },
          },
          city: {
            messages: {
              label: defineMessage({ id: "loyaltyCustomer.city", defaultMessage: "city" }),
            },
          },
          address: {
            messages: {
              label: defineMessage({ id: "loyaltyCustomer.address", defaultMessage: "address" }),
            },
          },
          zipCode: {
            messages: {
              label: defineMessage({ id: "loyaltyCustomer.zipCode", defaultMessage: "zipCode" }),
            },
          },
        },
      },
      communicationConsent: {
        widget: SwitchGroup,
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.communicationConsent",
            defaultMessage: "communicationConsent",
          }),
        },
      },
      locale: {
        widget: LocaleSelector,
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.locale",
            defaultMessage: "locale",
          }),
        },
      },
      customerTransactionData: {
        hidden: true,
      },
      preferencesList: {
        fieldWidget: LoyaltyPreferencesWidget({ sections: sections ?? [] }),
        messages: {
          label: defineMessage({
            id: "loyaltyCustomer.preferencesList",
            defaultMessage: "Preferences",
          }),
        },
      },
    }),
    [brandId, sections, organizationsReadOnly]
  );

  const CustomerSwitchRenderer = useCallback(
    ({ value, rows }: RendererProps<number>) => {
      const changeStatusCustomerCall = async (value: boolean, id: string) => {
        const isCustomerActivated = value ? 1 : 0;
        const request = new ChangeStatusCustomerRequest();
        request.setCustomerId(id);
        request.setStatus(isCustomerActivated);
        await changeStatusCustomer(request);
        setForceUpdate(forceUpdate + 1);
      };

      const isAgencyCustomer = (organizationsList: { [key: string]: any }[]) => {
        return organizationsList.some(({ organizationType }) => organizationType === 2);
      };

      return (
        <SwitchWrapper>
          <SwitchComponent
            value={!!value}
            onChange={async it => {
              it?.event.preventDefault();
              changeStatusCustomerCall(it?.event?.target?.checked, rows?.id);

              if (it?.event?.target?.checked && isAgencyCustomer(rows?.organizationsList)) {
                const popupResult = await SweetAlert.fire({
                  title: intl.formatMessage(customerMessages.popupWelcomeValidatedEmailTitle, {
                    email: rows?.emailAddress,
                  }),
                  text: intl.formatMessage(customerMessages.popupWelcomeValidatedEmailDescription, {
                    email: rows?.emailAddress,
                  }),
                  showCancelButton: true,
                  icon: "success",
                  cancelButtonText: intl.formatMessage(customerMessages.no),
                  confirmButtonText: intl.formatMessage(customerMessages.yes),
                  confirmButtonColor: APP_COLORS.green,
                  iconColor: APP_COLORS.green,
                });

                if (popupResult.isConfirmed) {
                  sendWelcomeValidatedEmailToCustomer(brand, rows?.id, rows?.emailAddress);
                }
              }
            }}
            field={{
              className: "witadmin-bs3",
            }}
            caller=""
            entity={{}}
          />
        </SwitchWrapper>
      );
    },
    [changeStatusCustomer, forceUpdate, intl, sendWelcomeValidatedEmailToCustomer, brand]
  );

  const tableColumns: TableColumns<Customer.AsObject> = {
    status: {
      renderer: CustomerSwitchRenderer,
      width: 90,
    },
    name: {
      renderer: TableRenderers.StringRenderer,
      width: 100,
    },
    lastName: {
      renderer: TableRenderers.StringRenderer,
      width: 160,
    },
    emailAddress: {
      renderer: TableRenderers.StringRenderer,
      width: 220,
    },
    phoneNumber: {
      renderer: TableRenderers.StringRenderer,
      width: 100,
    },
    birthDate: {
      renderer: TableRenderers.DateRenderer,
      width: 80,
    },
    location: {
      children: {
        // in order for the country to be exported in the csv files, we need to change the column name
        // because we store a global list of hidden column names in local storage "hiddenColumnNames"
        // and we already have a country column in the reservation list, then that makes this hidden
        // if two pages have the same column names.
        // FIXME: if we are going to store a list of columns to hide, make it per page, so they dont clash
        lCountry: {
          renderer: TableRenderers.mapRenderer(TableRenderers.StringRenderer, v => {
            return v?.country;
          }),
          width: 60,
        },
        city: {
          renderer: TableRenderers.mapRenderer(TableRenderers.StringRenderer, v => {
            return v?.city;
          }),
          width: 100,
        },
        address: {
          renderer: TableRenderers.mapRenderer(TableRenderers.StringRenderer, v => {
            return v?.address;
          }),
          width: 100,
        },
        zipCode: {
          renderer: TableRenderers.mapRenderer(TableRenderers.StringRenderer, v => {
            return v?.zipCode;
          }),
          width: 100,
        },
      },
    },
    referrer: {
      renderer: TableRenderers.StringRenderer,
      width: 80,
    },
    tierType: {
      renderer: TierRenderer,
      width: 100,
    },
    legalIdentifier: {
      renderer: TableRenderers.StringRenderer,
      width: 100,
    },
    locale: {
      renderer: TableRenderers.StringRenderer,
      width: 150,
    },
    organizationsList: {
      renderer: mapRenderer(StringRenderer, v => {
        if (!v || !v.length) {
          return undefined;
        }
        return v.map(it => it.ticker).toString();
      }),
      width: 200,
    },
    tagsList: {
      renderer: mapRenderer(StringRenderer, v => {
        if (!v || !v.length) {
          return undefined;
        }
        return v.toString();
      }),
      width: 200,
    },
    createdAt: {
      renderer: mapRenderer(DateRenderer, v => v || undefined),
      width: 200,
    },
    communicationConsent: {
      renderer: mapRenderer(
        StringRenderer,
        (v, intl) => intl.formatMessage(v ? customerMessages.yes : customerMessages.no),
        { align: "center" }
      ),
      width: 100,
      align: "center",
    },
    preferencesList: {
      renderer: mapRenderer(StringRenderer, preferences => {
        const tags: Record<string, LoyaltyTag> =
          sections
            ?.flatMap(it => it.tags)
            .reduce<Record<string, LoyaltyTag>>(
              (acc, tag) => ({
                ...acc,
                [tag.ticker]: tag,
              }),
              {}
            ) ?? {};

        return preferences
          .map(p => tags[p.ticker]?.getTranslation(currentLocale).name ?? p.ticker)
          .join(", ");
      }),
    },
  };
  const handleBuildLinkWithSession: (
    customerId: string,
    openLink: boolean
  ) => Promise<string | undefined> = useCallback(
    async (customerId, openLink) => {
      return httpClient
        .post<any, string>(`/api/loyalty/${brand}/session/${customerId}?email=${email}`, {})
        .then(result => {
          if (result) {
            const encodedAffiliate = btoa(email || "");
            const engineLinkWithSession = buildEngineUrl(
              mainDomain,
              customDomain,
              propertyTicker,
              isCallCenterUser,
              result,
              encodedAffiliate,
              btoa(userAttributes),
              config.engineBaseUrl,
              Boolean(chainData?.isChain)
            );
            if (openLink) {
              window.open(engineLinkWithSession, "_blank");
            }
            return result;
          }
        });
    },
    [
      httpClient,
      brand,
      email,
      mainDomain,
      customDomain,
      propertyTicker,
      isCallCenterUser,
      config.engineBaseUrl,
      chainData?.isChain,
      userAttributes,
    ]
  );

  const handleViewHistory = useCallback(
    (customerId: string) => {
      history.push(`/${propertyTicker}/loyalty-historical/${customerId}`);
    },
    [history, propertyTicker]
  );

  const canShowUpgradeLevelButton = useCallback(
    (row: Customer.AsObject) => {
      const allowed = permissions.find(it => it.section === SECTION.LOYALTY_HISTORICAL);
      return allowed?.show && allowed?.modify && row.tierType === TierType.DERIVED;
    },
    [permissions]
  );

  const handleBulkUpdate = useCallback(() => {
    history.push(`/${propertyTicker}/upgrade-tier`);
  }, [propertyTicker, history]);

  // The export carries the brand's customers unmasked, so it is only emailed to the operator, never downloaded
  // (WTT-12423).
  const handleSendCustomersExcel = useCallback(
    async ({ filterValues }: { filterValues?: Partial<CustomerFilters> }) => {
      if (!allTiers) return;

      try {
        // Same filters as the list on screen, so the file holds the operator's selection (WTT-11290).
        // Page number and size are ignored: the export streams every customer matching the filters.
        const filters: Record<string, string> = {};
        buildListCustomerRequest(allTiers, {
          brandId,
          filterValues: filterValues ?? {},
          currentPage: 0,
          pageSize: 0,
        })
          .getFiltersMap()
          .forEach((value, key) => {
            if (value) filters[key] = value;
          });

        await backofficeClient.post(
          `/v1/loyalty/proxy/${brand}/customers/file/send`,
          {},
          {
            params: filters,
            timeout: 120_000,
          }
        );
        await SweetAlert.fire({
          icon: "info",
          text: intl.formatMessage(customerMessages.sendCustomersExcelEmailSuccess, {
            email: userProfile?.email,
          }),
          cancelButtonText: `${intl.formatMessage(customerMessages.ok)}`,
        });
      } catch (e) {
        if (e instanceof AxiosError && e.response && e.response.status === 429) {
          await SweetAlert.fire({
            icon: "warning",
            text: intl.formatMessage(customerMessages.unmaskedErrorTooManyRequests),
            cancelButtonText: `${intl.formatMessage(customerMessages.ok)}`,
          });
        } else {
          await SweetAlert.fire({
            icon: "error",
            text: intl.formatMessage(customerMessages.sendCustomersExcelEmailError),
            cancelButtonText: `${intl.formatMessage(customerMessages.ok)}`,
          });
        }
      }
    },
    [allTiers, backofficeClient, brand, brandId, intl, userProfile?.email]
  );

  const handleSendUnmaskedCustomer = useCallback(
    async (id: string) => {
      try {
        setUnmaskedSendLoading(true);
        // Through backoffice-manager: customer-rewards only sends unmasked data when the proxy has
        // checked the property against the brand.
        await backofficeClient.post(`/v1/loyalty/proxy/${brand}/customers/${id}/send`, {});
        await SweetAlert.fire({
          icon: "info",
          text: intl.formatMessage(customerMessages.sendUnmaskedCustomerEmailSuccess, {
            email: userProfile?.email,
          }),
          cancelButtonText: `${intl.formatMessage(customerMessages.ok)}`,
        });
      } catch (e) {
        if (e instanceof AxiosError && e.response && e.response.status === 429) {
          await SweetAlert.fire({
            icon: "warning",
            text: intl.formatMessage(customerMessages.unmaskedErrorTooManyRequests),
            cancelButtonText: `${intl.formatMessage(customerMessages.ok)}`,
          });
        } else {
          await SweetAlert.fire({
            icon: "error",
            text: intl.formatMessage(customerMessages.sendUnmaskedCustomerEmailError),
            cancelButtonText: `${intl.formatMessage(customerMessages.ok)}`,
          });
        }
      } finally {
        setUnmaskedSendLoading(false);
      }
    },
    [backofficeClient, brand, intl, userProfile?.email]
  );

  const TableRowActions = useCallback(
    ({ row, rest }: DefaultTableRowActionsProps<Customer.AsObject>) => {
      return (
        <Table.Cell {...rest}>
          {/*navigation.goToEditForm doesn't workk here for some reason*/}
          <StyledReactTooltip id="edit" effect="solid">
            <FormattedMessage {...customerMessages.edit} />
          </StyledReactTooltip>
          <StyledReactTooltip id="view" effect="solid">
            <FormattedMessage {...customerMessages.view} />
          </StyledReactTooltip>
          {canViewUnmaskedData && (
            <StyledReactTooltip id="send" effect="solid">
              <FormattedMessage {...customerMessages.sendUnmaskedCustomerTooltip} />
            </StyledReactTooltip>
          )}
          <StyledReactTooltip id="login" effect="solid">
            <FormattedMessage {...customerMessages.login} />
          </StyledReactTooltip>
          <StyledReactTooltip id="delete" effect="solid">
            <FormattedMessage {...customerMessages.delete} />
          </StyledReactTooltip>
          <StyledReactTooltip id="editLevel" effect="solid">
            <FormattedMessage {...customerMessages.editLevel} />
          </StyledReactTooltip>
          <Edit
            onGoToEdit={id => history.push(`${match.url}/edit/${id}`)}
            // We need to remove the fake attribute we added manually or jsonSchema will attempt to render it
            // and marking it as hidden will not work. This only happens when clicking the edit button because
            // of how the Edit works, by storing the JSONified row in local storage
            row={{ ...row, lCountry: undefined }}
            readonly={isB2bMember(row)}
          />
          {canViewUnmaskedData && (
            <Button
              data-tip="React-tooltip"
              data-for="send"
              size="sm"
              className="mr-2"
              variant="light"
              onClick={() => handleSendUnmaskedCustomer(row?.id)}
              disabled={unmaskedSendLoading}>
              <FontAwesomeIcon icon={faPaperPlane} />
            </Button>
          )}
          {isDreamplaceEngine(propertyTicker) ? (
            <ImpersonateLoyaltyCustomer
              customerId={row?.id}
              sessionBuilder={handleBuildLinkWithSession}
              propertyTicker={propertyTicker}
              email={email ?? ""}
              isCallCenterUser={isCallCenterUser}
              engineURL={config.engineBaseUrl}
            />
          ) : (
            <Button
              disabled={false}
              data-tip="React-tooltip"
              data-for="login"
              size="sm"
              className="mr-2"
              variant="light"
              onClick={() => handleBuildLinkWithSession(row?.id, true)}>
              <FontAwesomeIcon icon={faSignInAlt} />
            </Button>
          )}
          <Delete
            rest={rest}
            onDelete={onDelete}
            row={row}
            shouldDisable={customer => isB2bMember(customer) && "b2b"}
            messages={{
              ...defaultDeleteMessages,
              deleteDisabledDescription: customerMessages.b2bMemberManagedBySalesforce,
            }}
            onReloadList={() => {
              console.info("reload");
              setReload(!reload);
            }}
          />
          <Button
            data-tip="React-tooltip"
            data-for="editLevel"
            size="sm"
            className={`ml-2 ${!canShowUpgradeLevelButton(row) ? "invisible" : "visible"}`}
            variant="light"
            onClick={() => handleViewHistory(row?.id)}>
            <FontAwesomeIcon icon={faSortAmountUp} />
          </Button>
        </Table.Cell>
      );
    },
    [
      canViewUnmaskedData,
      unmaskedSendLoading,
      propertyTicker,
      handleBuildLinkWithSession,
      email,
      isCallCenterUser,
      onDelete,
      canShowUpgradeLevelButton,
      isB2bMember,
      history,
      match.url,
      handleSendUnmaskedCustomer,
      reload,
      handleViewHistory,
      config.engineBaseUrl,
    ]
  );

  // not using translations for managerName because filter storage won't work on language change
  return (
    <>
      {brand && (
        <SimpleCrud<Customer.AsObject, CustomerFilters>
          schema={modifiedSchema}
          formConfiguration={formConfiguration}
          tableColumns={tableColumns}
          tableFilters={tableFilters}
          formContainer={FormContainer}
          messages={customerMessages}
          onGetAll={onGetAll}
          paging={true}
          defaultPageSize={defaultPageSize}
          pageSizes={pageSizes}
          onGetOne={onGetOne}
          columnVisibility={true}
          onCreate={onCreate}
          canCreate={actions.CreateLoyaltyCustomers}
          columnVisibilityExtensions={columnVisibilityExtensions}
          managerName={"customers"}
          CSVRenderers={CSVRenderers}
          onUpdate={onUpdate}
          readOnly={isB2bMember}
          section={SECTION.LOYALTY_CUSTOMERS}
          rowActions={props => <TableRowActions {...props} />}
          forceLoad={forceUpdate}
          onDelete={onDelete}
          canBulkUpdate={actions.ModifyLoyaltyCustomerHistorical}
          onBulkUpdate={handleBulkUpdate}
          onExport={handleSendCustomersExcel}
          onExportText={intl.formatMessage(customerMessages.exportButton)}
          hideExportButton={
            !canViewUnmaskedData || !authorizer.canExecute(authorizeActions.SendUnmaskedData)
          }
        />
      )}
    </>
  );
}

export default withAuthorizationVerifier(LoyaltyCustomerCrud);
